import { isCustomerRole } from "@nlc/shared-types";

const usTimezones: Set<string> = new Set([
  "America/Adak",
  "America/Atka",
  "America/Anchorage",
  "America/Juneau",
  "America/Nome",
  "America/Yakutat",
  "America/Los_Angeles",
  "America/Boise",
  "America/Denver",
  "America/Phoenix",
  "America/Shiprock",
  "America/Chicago",
  "America/Knox_IN",
  "America/Menominee",
  "America/Detroit",
  "America/Fort_Wayne",
  "America/Indianapolis",
  "America/Louisville",
  "America/New_York",
]);

export function showSmsChannel(
  roleId: number | undefined,
  timezone: string | undefined,
): boolean {
  if (!roleId || !timezone) return false;
  const isCustomer = isCustomerRole(roleId);
  const isUSTimezone = usTimezones.has(timezone);

  return isCustomer && isUSTimezone;
}
